<template>
  <v-row justify="center">
    <v-dialog v-model="openModal" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5">
          Nomor Laporan: {{ data.id }}
        </v-card-title>
        <v-card-text>Deskripsi: {{ data.deskripsi_kejadian }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="danger darken-1" text @click="$emit('close-modal')">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  name: "ShowModal",
  props: ["openModal", "data"],
  data() {
    return {};
  }
};
</script>
